import { render, staticRenderFns } from "./tips.vue?vue&type=template&id=707e880a&scoped=true&"
import script from "./tips.vue?vue&type=script&lang=js&"
export * from "./tips.vue?vue&type=script&lang=js&"
import style0 from "./tips.vue?vue&type=style&index=0&id=707e880a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707e880a",
  null
  
)

export default component.exports